<template>
<div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
        <li class="breadcrumb-item">
            <router-link to="/purchase/orders">{{ $t('purchase_order_list') }}</router-link>
        </li>
        <li class="breadcrumb-item">
            <router-link to="/po/invoices">{{ $t('purchase_invoice') }}</router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">[{{invoice.DocSourceNo}}]</li>
    </ol>
    <div class="x_header">
        <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-chevron-circle-left" aria-hidden="true"></i> {{ $t('back') }}</button>
        <b-btn variant="outline-primary no-bor"
               size="sm"
               @click="save">
            <i class="fa fa-floppy-o" aria-hidden="true"/> {{$t('save')}}
        </b-btn>
    </div>
    <div class="x_body">
        <div class="card x_card">
            <div class="card-body">
                <div class="row">
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{ $t('vendor') }}</label>
                            <div>
                                <input type="text" class="form-control form-control-sm" readonly v-model="invoice.PartnerName">
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{ $t('date') }}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="invoice.Date"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{ $t('due_date') }}</label>
                            <div>
                                <input type="date" class="form-control form-control-sm" v-model="invoice.DueDate"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-2">
                        <div class="form-group">
                            <label class="control-label blue">{{ $t('purchase_order_no') }}</label>
                            <div>
                                <input type="text" class="form-control form-control-sm" v-model="invoice.DocSourceNo" readonly/>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-sm-12">
                        <table class="table table-sm table-bordered table-striped no-bor">
                            <thead>
                                <tr>
                                    <th style="width: 30px;">{{$t('no')}}</th>
                                    <th>{{$t('item_name')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('qty')}}</th>
                                    <th class="text-center" style="width: 100px;">{{$t('uom')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('unit_price')}}</th>
                                    <th class="text-right" style="width: 100px;">{{$t('tax_line')}}(%)</th>
                                    <th class="text-right" style="width: 100px;">{{$t('sub_total')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(ret,index) in lines" :key="ret.Id">
                                    <td class="text-center" style="width: 30px;">{{index+1}}</td>
                                    <td>{{ret.ItemName}}</td>
                                    <td class="text-center">{{ret.Quantity}}</td>
                                    <td class="text-center">{{ret.UomName}}</td>
                                    <td class="text-right">{{$dollar(ret.Price)}}</td>
                                    <td class="text-right">{{ret.TaxLine}}</td>
                                    <td class="text-right">{{$dollar(ret.SubTotal)}}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="6" class="text-right">{{$t('untax_amount')}}</th>
                                    <th class="text-right">{{$dollar(invoice.GrandTotal)}}</th>
                                </tr>
                                <tr>
                                    <th colspan="6" class="text-right">{{$t('total')}}</th>
                                    <th class="text-right">{{$dollar(invoice.PaidAmount)}}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
    export default {
        data: function(){
            return {
                invoice: {
                    Date: this.$now().format('YYYY-MM-DD'),
                    DueDate: this.$now().format('YYYY-MM-DD'),
                    VendorId: '',
                    PartnerName: '',
                    GrandTotal: 0,
                    UntaxAmount: 0,
                    TaxVat: 0,
                    TotalAmount: 0,
                    PaidAmount: 0,
                    Status: 'Draft',
                    DocSourceNo: '',
                    DocSource: 'Order'
                },
                lines: [],
                actionLink: 'po/invoice/save',
            }
        },
        created: function(){
            let id = this.$route.params.id;
            this.findById(id);
        },
        methods: {
            save(){
                var req = {
                    Header: this.invoice,
                    Lines: this.lines
                };
                let loading = this.$loading.show();
                this.$api().post(this.actionLink, req).then(res => {
                    if(this.$isValid(res)){this.$router.push('/po/invoices');}
                }).finally(function(){ loading.hide(); });
            },
            findById(id){
                let loading = this.$loading.show();
                this.$api().post('purchase/order/find', { Id: id}).then(res => {
                    var data = res.data.Json;
                    this.invoice.VendorId = data.Header.VendorId;
                    this.invoice.PartnerName = data.Header.PartnerName;
                    this.invoice.GrandTotal = data.Header.GrandTotal;
                    this.invoice.UntaxAmount = data.Header.GrandTotal;
                    this.invoice.TaxVat = data.Header.TaxVat;
                    this.invoice.PaidAmount = data.Header.PaidAmount;
                    this.invoice.Balance = data.Header.PaidAmount;
                    this.invoice.DocSourceNo = data.Header.Num;
                    this.invoice.PONum = data.Header.Num;
                    data.Lines.forEach(element => {
                        this.lines.push({
                            ItemId: element.ItemId,
                            ItemName: element.ItemName,
                            Quantity: element.Quantity,
                            Price: element.Price,
                            UomId: element.UomId,
                            UomName: element.UomName,
                            TaxLine: element.TaxLine,
                            SubTotal: element.SubTotal
                        });
                    });
                }).finally(function(){ loading.hide(); });
            }
        }
    }
</script>
<style scoped>x
    label{
        margin-bottom: 0;
    }
</style>
